import { t$2 } from '@/js/global/global'
import { wrapIframes, wrapTables } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { Accordions } from '@/js/modules/accordions'

register("contact", {
  onLoad() {
    this.accordions = Accordions(t$2(".accordion", this.container));
    wrapIframes(t$2("iframe", this.container));
    wrapTables(t$2("table", this.container));
  },
  onUnload() {
    this.accordions.unload();
  }
});
